export default {
  atterbergLimit: {
    AASHTO_T89_T90: {
      methodA_Rev2013_2020: '110442',
      methodB_Rev2013_2020: '110443',
    },
  },
  maximumDryDensity: {
    AASHTO_T99: { rev2015: '110423', rev2015_metric: '110424' },
    AASHTO_T180: { rev2015: '110425', rev2015_metric: '110426' },
  },
  moistureContent: {
    AASHTO_T_265: { rev2015: '110100' },
  },
  oversizeDetermination: { AASHTO_T99_T180: '110428' },
  psdSieveAnalysis: {
    AASHTO_T_27: { rev2020: '110432' },
  },
  specificGravityCoarse: {
    AASHTO_T_85: { rev2014: '110422' },
  },
  wash: {
    AASHTO_T_11: { rev2020: '110451' },
  },
};
